import { LOGIN, CLEAR_LOGIN_FAILED } from '../constants/ActionTypes';

const loggedIn = (state = {isLoggedIn: false}, action) => {
  switch (action.type) {
    case LOGIN:
      if (action.isLoggedIn.isLoggedIn) {
        return action.isLoggedIn;
      } else {
        return {
          ...action.isLoggedIn,
          isLoggedIn: false,
        };
      }
    case CLEAR_LOGIN_FAILED:
      return { isLoggedIn: false };
    default:
      return state;
  }
}

export default loggedIn;



// WEBPACK FOOTER //
// ./src/reducers/loggedIn.js